import API from "./API";

export const getAthleteRegistration = (token) => {
    return API.get(`/athlete/registration/${token}`)
}